
import { Telemetry, ValidTelemetryEvent } from '~commonInfra/services/Telemetry';

export const connectDisconnectEventType = 'site_msteams_connection';
export const upgradeMsTeamsConnectionEventType = 'site_msteams_upgrade';
export const userReturnFromMsTeamsEventType = 'user_return_from_msteams';
export const commentingMentionNotificationType = 'commentingMention';
export const dataDrivenAlertNotificationType = 'dataDrivenAlert';
export const sharingNotificationType = 'sharing';
export const editAlertLinkType = 'editAlert';
export const viewLinkType = 'view';

export interface ConnectToMsTeamsEvent extends ValidTelemetryEvent {
  type: string;
  user_id: string;
  site_luid: string;
  is_connect: boolean; // If value is true, this is a "Connect to Microsoft Teams" event. If value is false, it is a "Disconnect from Microsoft Teams" event
  version: string | null; // non-null if and only if type is site_msteams_upgrade
}

export interface ReturnLinkFromMsTeamsEvent extends ValidTelemetryEvent {
  type: string;
  user_id: string;
  site_luid: string;
  notification_type: string;
  link_type: string;
}

interface ConnectDisconnectMsTeamsEventParams {
  userId: string;
  siteLuid: string;
  connectToMsTeams: boolean;
}

export function sendConnectToMsTeamsTelemetry(params: ConnectDisconnectMsTeamsEventParams) {
  Telemetry.sendEvent<ConnectToMsTeamsEvent>({
    type: connectDisconnectEventType,
    user_id: params.userId,
    site_luid: params.siteLuid,
    is_connect: params.connectToMsTeams,
    version: null
  });
}

interface UpgradeMsTeamsConnectionEventParams {
  userId: string;
  siteLuid: string;
  version: string;
}

export function sendUpgradeMsTeamsConnectionTelemetry(params: UpgradeMsTeamsConnectionEventParams) {
  Telemetry.sendEvent<ConnectToMsTeamsEvent>({
    type: upgradeMsTeamsConnectionEventType,
    user_id: params.userId,
    site_luid: params.siteLuid,
    is_connect: true,
    version: params.version,
  });
}

interface ReturnFromMsTeamsEventParams {
  userId: string;
  siteLuid: string;
  notificationType: string;
  linkType: string;
}

export function sendReturnFromMsTeamsTelemetry(params: ReturnFromMsTeamsEventParams) {
  Telemetry.sendEvent<ReturnLinkFromMsTeamsEvent>({
    type: userReturnFromMsTeamsEventType,
    user_id: params.userId,
    site_luid: params.siteLuid,
    notification_type: params.notificationType,
    link_type: params.linkType,
  });
}